<ion-content class="bg-color ion-content profile">
  <div class="com-content">
    <div class="content-breadcrumb">
      <ul class="breadcrumb">
        <li *ngFor="let itemList of breadcrumbList" class="breadcrumb-item">
          <ng-container *ngIf="itemList.embedurl; else noRoute">
            <a href="javascript:void(0)" routerLink="{{ itemList.url }}">
              {{ itemList.label }}
            </a>
          </ng-container>
          <ng-template #noRoute>
            <a style="text-decoration: none; cursor: none;" href="javascript:void(0)">
              {{ itemList.label }}
            </a>
          </ng-template>

        </li>
      </ul>
    </div>
    <div class="content-grid">
      <div class="m-content">
        <form [formGroup]="updateProfileform" (ngSubmit)="onSubmit()">
          <mat-card>
            <mat-card-content class="mc-content">
              <div class="form-container" style="background-color: #fbfbfb; border: 1px solid #f0f0f8;">
                <div class="logo-layout">
                  <div class="image-xe profile-image">
                    <div class="p-image">
                      <img [src]="profileImagePath">
                    </div>
                    <div class="file-upload">
                      <input type="file" id="profile_image" #profileImage accept="image/x-png,image/jpeg"
                       (change)="uploadProfileImage($event)" style="width: 92px; display: none;">
                      <button type="button" (click)="onProfile($event)" class="upload-img">
                        {{ hasProfile?'Change Profile':'Add Profile'}}
                      </button>
                      <mat-icon matTooltip="Delete Profile" (click)="clearProfileImage()" color="warn">delete</mat-icon>
                    </div>
                    <p style="color: #000000; padding: 10px 0;">Profile image upload file format of jpg, jpeg and png
                      only upto size of 200KB</p>
                  </div>
                  <hr>
                  <div class="image-xe company-logo" *ngIf="roleId == 2">
                    <div class="logo">
                      <img [src]="companyLogoPath">
                    </div>
                    <div class="file-upload">
                      <input type="file" id="profile_company_logo" #companyLogo (change)="uploadCompanyLogo($event)"
                        accept="image/x-png,image/jpeg" style="width: 92px; display: none;">
                      <button type="button" (click)="onProfileLogo($event)" class="upload-img">
                        {{ hasProfileLogo? 'Change Company Logo':'Add Company Logo'}}
                      </button>
                      <mat-icon matTooltip="Delete Company Logo" (click)="clearCompanyLogo()" color="warn">delete</mat-icon>
                    </div>
                    <p style="color: #000000; padding: 10px 0;">Company logo upload file format of jpg, jpeg and png
                      only upto size of 100KB</p>
                  </div>
                </div>
              </div>
              <div class="form-container">
                <div class="form-layout">
                  <mat-form-field appearance="outline">
                    <mat-label>First name</mat-label>
                    <input type="text" id="profile_firstname" formControlName="firstName" matInput
                      placeholder="First name" required>
                    <mat-error *ngIf="updateProfileform.get('firstName').hasError('pattern')">
                      First Name Allows Alphanumeric Only!
                    </mat-error>
                    <mat-error *ngIf="updateProfileform.get('firstName').hasError('required')">
                      First Name is Required!
                    </mat-error>
                    <!-- <mat-error *ngIf="submitted && f.firstName.hasError('required')">First Name Required. </mat-error> -->
                    <!-- <mat-error *ngIf="updateProfileform.get('firstName').hasError('pattern')">
                        First Name Allows Alphabet Only!
                      </mat-error>
                      <mat-error *ngIf="updateProfileform.get('firstName').hasError('required')">
                        First Name is Required!
                      </mat-error> -->
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Last name</mat-label>
                    <input type="text" id="profile_lastname" formControlName="lastName" matInput placeholder="Last name"
                      required>
                    <mat-error *ngIf="updateProfileform.get('lastName').hasError('pattern')">
                      Last Name Allows Alphanumeric Only!
                    </mat-error>
                    <mat-error *ngIf="updateProfileform.get('lastName').hasError('required')">
                      Last Name is Required!
                    </mat-error>
                    <!-- <mat-error *ngIf="submitted && f.lastName.hasError('required')">Last Name Required. </mat-error> -->
                  </mat-form-field>
                </div>
                <div class="form-layout">
                  <mat-form-field appearance="outline">
                    <mat-label>Work email</mat-label>
                    <input type="text" id="profile_email" formControlName="email" matInput
                      placeholder="Work email Address" required readonly>
                    <!-- <mat-error *ngIf="submitted && f.email.hasError('required')">Work email Required. </mat-error> -->
                    <!-- <mat-error *ngIf="submitted && f.email.hasError('email')">Email must be Valid. </mat-error> -->
                  </mat-form-field>
                  <mat-form-field appearance="outline" *ngIf="roleId == 2">
                    <mat-label>Phone number</mat-label>
                    <!-- <span matPrefix>+91 &nbsp;&nbsp;</span> -->
                    <input type="text" id="profile_phone" minlength="10" maxlength="18" formControlName="phone" matInput
                      placeholder="Phone number" required>
                    <!-- <mat-error *ngIf="submitted && f.phone.hasError('required')">Phone number Required. </mat-error> -->

                    <!-- <mat-error *ngIf="updateProfileform.get('phone').hasError('pattern')">
                        Please Enter a Valid Phone Number
                      </mat-error> -->
                    <mat-error *ngIf="updateProfileform.get('phone').hasError('required')">
                      Phone Number is Required!
                    </mat-error>
                    <mat-error *ngIf="updateProfileform.get('phone').hasError('minlength')">
                      <!-- Minimum length should be 10 digits -->
                      Please Enter a Valid 10 digit Phone Number
                    </mat-error>
                    <mat-error *ngIf="updateProfileform.get('phone').hasError('maxlength')">
                      Maximum length should be 18 digits
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="form-layout" *ngIf="roleId == 2">
                  <mat-form-field appearance="outline">
                    <mat-label>Job Title</mat-label>
                    <mat-select formControlName="jobTitle" id="profile_job" required>
                      <mat-option>-- Select --</mat-option>
                      <mat-option *ngFor="let job of jobTitle" value="{{job.name}}">{{job.name}}</mat-option>
                    </mat-select>
                    <!-- <mat-error *ngIf="submitted && f.jobTitle.hasError('required')">Job Title Required. </mat-error> -->
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Employee</mat-label>
                    <mat-select formControlName="employee" id="profile_employee" required>
                      <mat-option>-- Select --</mat-option>
                      <mat-option *ngFor="let emp of employee" value="{{emp.name}}">{{emp.name}}</mat-option>
                    </mat-select>
                    <!-- <mat-error *ngIf="submitted && f.employee.hasError('required')">Employee Required. </mat-error> -->
                  </mat-form-field>
                </div>
                <div class="form-layout" *ngIf="roleId == 2">
                  <mat-form-field appearance="outline">
                    <mat-label>Company</mat-label>
                    <input type="text" id="profile_company" formControlName="company" matInput placeholder="Company"
                      required>
                    <!-- <mat-error *ngIf="submitted && f.company.hasError('required')">Company Required. </mat-error> -->
                    <mat-error *ngIf="updateProfileform.get('company').hasError('required')">
                      Company Name Is Required!
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Country</mat-label>
                    <mat-select formControlName="country" id="profile_country" required>
                      <mat-option>-- Select --</mat-option>
                      <mat-option *ngFor="let country of countries"
                        value="{{country.country_name}}">{{country.country_name}}</mat-option>
                    </mat-select>
                    <!-- <mat-error *ngIf="submitted && f.country.hasError('required')">Country Required. </mat-error> -->
                    <mat-error *ngIf="updateProfileform.get('country').hasError('required')">
                      Country Name Is Required!
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="form-layout" *ngIf="roleId == 2">
                  <mat-form-field appearance="outline">
                    <mat-label>Company Address</mat-label>
                    <textarea matInput rows="5" cols="40" id="profile_company_address" formControlName="company_address"
                      placeholder="Company Address"></textarea>
                  </mat-form-field>
                </div>
                <div class="form-layout">

                  <mat-label class="mfa_toggle">Enable Multi Factor Authentication</mat-label><br>
                  <mat-slide-toggle class="mfa_toggle" #toggle formControlName="mfa_enabled"
                    (change)="enableMfaToggle($event)"></mat-slide-toggle>

                </div>

                <div class="form-layout" *ngIf="(roleId == 1 && isVisualizationAccessEnableFromENV) || (roleId == 2 && isVisualizationAccessEnableFromENV)">

                  <mat-label class="mfa_toggle">Enable Bizintel360 Visualization</mat-label><br>
                  <mat-slide-toggle class="mfa_toggle" #toggle formControlName="enableVAToggle"
                    (change)="enableVAToggle($event)"></mat-slide-toggle>

                </div>

                <div class="form-layout" *ngIf="(roleId == 1 && isVisualizationAccessEnableFromENV) || (roleId == 2 && isVisualizationAccessEnableFromENV)">

                  <mat-label class="mfa_toggle">Enable Goldfinch AI Agent</mat-label><br>
                  <mat-slide-toggle class="mfa_toggle" #toggle formControlName="enableGoldfinchToggle"
                    (change)="enableGoldfinchToggle($event)"></mat-slide-toggle>
                </div>

                <div>
                  <button mat-raised-button routerLink="/baseapp/profile/api-settings" *ngIf="apiSettingsEnable">Api-Setting</button>
                </div>

                <div class="btn-signup-grid">
                  <!-- <button mat-raised-button class="btn" routerLink="/baseapp">Back</button> -->
                  <button mat-raised-button type="button" (click)="onSubmit()" id="profile_submit" class="btn btn-signup">Update</button>
                </div>
                <!-- <div class="links-grid">
                    <mat-checkbox formControlName="agreeSubscription" required>I agree to the  <a style="text-decoration: none;" class="signin-link" href="javascript:void(0)">Master Subscription Agreement</a></mat-checkbox>
                    <mat-error *ngIf="submitted && f.agreeSubscription.hasError('required')">Please accept Master subscription. </mat-error>
                    <p>By registering you confirm that agree to stroring and processing of your personal data by Bizdata as described in the privacy statement</p>
                  </div> -->

              </div>
            </mat-card-content>
          </mat-card>


        </form>

      </div>
       <!-- <app-api-settings></app-api-settings> -->
      <!-- <app-about-page *ngIf="hide1200"></app-about-page> -->
    </div>
    <app-footer></app-footer>
  </div>
</ion-content>
